<ng-container *ngIf="branchData.length === 1; else multipleBranches">
  <div [innerHTML]="branchData[0].branchDisplay | translate | iTrustThisHtml"></div>
</ng-container>
<ng-template #multipleBranches>
  <ng-container *ngFor="let branch of branchData; let first = first">
    <div
      class="box-label first"
      *ngIf="first"
      [innerHTML]="
        'AUTOMATIONS.EDITOR.BRANCH.FIRST_CHECK_BRANCH' | translate: { branchName: branch.branchName } | iTrustThisHtml
      "
    ></div>
    <div
      class="box-label"
      *ngIf="!first"
      [innerHTML]="
        'AUTOMATIONS.EDITOR.BRANCH.ELSE_CHECK_BRANCH' | translate: { branchName: branch.branchName } | iTrustThisHtml
      "
    ></div>
    <div class="box-content-outer">
      <div
        class="box-content-inner new-restricted-content-height"
        [innerHTML]="branch.branchDisplay | translate | iTrustThisHtml"
      ></div>
    </div>
  </ng-container>
</ng-template>
